import { OutreachProgram } from "../types/outreach";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { ProgramForm } from "./ProgramForm";

interface NewProgramDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSave?: (program: Partial<OutreachProgram>) => void;
}

export function NewProgramDialog({ open, onOpenChange, onSave }: NewProgramDialogProps) {
  const handleSubmit = (data: any) => {
    onSave?.(data);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Create New Program</DialogTitle>
        </DialogHeader>

        <ProgramForm
          onSubmit={handleSubmit}
          onCancel={() => onOpenChange(false)}
          submitLabel="Create Program"
        />
      </DialogContent>
    </Dialog>
  );
}
